import React, { Fragment } from 'react';
import { Button } from '@company-mrv/mrv-design-system/components';
import ModalComBotaoFechar from '../../../../../../lib/components/modalComBotaoFechar/modalComBotaoFechar';
import MensagemModal from '../../../../../../lib/components/mensagemModal/mensagemModal';

class EnviarEventGrid extends React.Component<{
    enviarParametrosEventGrid: Function
}, {
    sucessoReenviarParamentro: boolean,
    falhaReenviarParamentro: boolean,
    loadingReenviarParametro: boolean
}> {

    constructor(props: any) 
    {
        super(props);
        this.state = {
            sucessoReenviarParamentro: false,
            falhaReenviarParamentro: false,
            loadingReenviarParametro: false
        };

        this.limparMensagensSucessoErro = this.limparMensagensSucessoErro.bind(this);
        this.possuiMensagemRetorno = this.possuiMensagemRetorno.bind(this);
    }

    limparMensagensSucessoErro(): void 
    {
        this.setState({
            sucessoReenviarParamentro: false,
            falhaReenviarParamentro: false
        });
    }

    possuiMensagemRetorno(): boolean 
    {
        return this.state.sucessoReenviarParamentro || this.state.falhaReenviarParamentro;
    }

    tratarEnvioEventGrid = async () => {
        this.setState({
            loadingReenviarParametro: true,
            falhaReenviarParamentro: false,
            sucessoReenviarParamentro: false
        });

        this.props.enviarParametrosEventGrid()
            .then(() => 
            {
                this.setState({
                    sucessoReenviarParamentro: true,
                    falhaReenviarParamentro: false,
                    loadingReenviarParametro: false
                });
            })
            .catch(() => 
            {
                this.setState({
                    sucessoReenviarParamentro: false,
                    falhaReenviarParamentro: true,
                    loadingReenviarParametro: false
                });
            });
    }

    render() 
    {
        return (
            <Fragment>
                <Button loading={this.state.loadingReenviarParametro} size="small" variant="ghost" className="botao" onClick={this.tratarEnvioEventGrid}>Reenviar parâmetros</Button>
                <ModalComBotaoFechar
                    isOpen={this.possuiMensagemRetorno()}
                    onRequestClose={this.limparMensagensSucessoErro}
                    aoClicarBotaoFecharModal={this.limparMensagensSucessoErro}>
                        {this.state.sucessoReenviarParamentro && <MensagemModal mensagem="Parametro reenviado com sucesso"></MensagemModal>}
                        {this.state.falhaReenviarParamentro && <MensagemModal mensagem="Erro ao reenviar parametro" erro={true}></MensagemModal>}
                </ModalComBotaoFechar>
            </Fragment>
        );
    }
}

export default EnviarEventGrid